export var ChipTestIds = {
    /** Test ID to grab the root element */
    ROOT: 'hawkins-chip-root',
    /** Test ID to grab the label element */
    LABEL: 'hawkins-chip-label',
    /** Test ID to grab the `startAdornment` element */
    START_ADORNMENT: 'hawkins-chip-start-adornment',
    /** Test ID to grab the `endAdornment` element */
    END_ADORNMENT: 'hawkins-chip-end-adornment',
};
